import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import en from "./en.json";
import de from "./de.json";

const DICTS = { en, de };
export const LANGUAGES = ["en", "de"];
const STORAGE_KEY = "immo_lang";

function getInitialLang() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (LANGUAGES.includes(saved)) return saved;
  } catch { /* localStorage unavailable */ }
  return "en";
}

function resolve(dict, key) {
  return key.split(".").reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), dict);
}

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(getInitialLang);

  const setLang = useCallback((l) => {
    if (!LANGUAGES.includes(l)) return;
    setLangState(l);
    try { localStorage.setItem(STORAGE_KEY, l); } catch { /* localStorage unavailable */ }
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  // {{var}} interpolation, e.g. t("watchlist.savedCount", { count: 3 })
  const t = useCallback((key, vars) => {
    let str = resolve(DICTS[lang], key);
    if (str === undefined) str = resolve(DICTS.en, key);
    if (str === undefined) return key;
    if (vars) {
      for (const [k, v] of Object.entries(vars)) {
        str = str.replace(new RegExp(`{{${k}}}`, "g"), v);
      }
    }
    return str;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
